/**
 *
 * Number formatter - formats numbers with their appropriate suffix. (1 -> 1st, 2 -> 2nd, 12 -> 12th) 
 * 
 */

function formatNumberWithSuffix(valueToFormat) {

    let numberToFormat = undefined;
    if (Number.isInteger(valueToFormat)) {
        numberToFormat = valueToFormat;
    }
    else {
        numberToFormat = parseInt(valueToFormat, 10);
        if (Number.isNaN(numberToFormat)) {
            return valueToFormat;
        }
    }

    let lastDigit = numberToFormat % 10;

    let checkTensies = function(chkVal) {
        let tensiesCheckValue = (chkVal % 100);
        let tensiesCheck = ((tensiesCheckValue >= 10) && (tensiesCheckValue < 20));
        return tensiesCheck;
    };

    let suffix = "";
    switch (lastDigit) {
        case 1:
            suffix = (checkTensies() ? "th" : "st" );
            break;
        case 2:
            suffix = (checkTensies() ? "th" : "nd" );
            break;
        case 3:
            suffix = (checkTensies() ? "th" : "rd" );
            break;
        default:
            suffix = "th";
    }

    let formattedNumber = `${numberToFormat}${suffix}`;
    return formattedNumber;
}

export default formatNumberWithSuffix;




//////////////////
// WEBPACK FOOTER
// ./src/utility/NumberFormatter.js
// module id = EvJa
// module chunks = 1